import helper from '@/libs/forms';

const types = [
  { name: 'Other', id: 'other' },
  { name: 'Home', id: 'home' },
  { name: 'Company', id: 'company' },
  { name: 'Cell Phone', id: 'mobile' },
  { name: 'Fax', id: 'fax' },
];

export default {
  schema: {
    fields: [
      {
        type: 'array',
        label: 'Phones',
        model: 'phones',
        showRemoveButton: true,
        styleClasses: 'col-md-12',
        itemContainerClasses: 'pb-2 phone-item-container',
        itemFieldClasses: 'item-field-class',
        newElementButtonLabelClasses: 'btn btn-outline-anchor btn-sm mt-2 float-right',
        removeElementButtonClasses: 'btn btn-danger remove-phone-btn',
        newElementButtonLabel: '+ Add Phone',
        required: true,
        validator: 'array',
        items: {
          type: 'object',
          default: {},
          schema: {
            fields: [
              helper.simpleSelect('Type', 'type', true, types, '-', 4),
              helper.phone('Number', 'number', true, 8),
            ],
          },
        },
      },
    ],
  },
  options: helper.options('contact-phones-', true),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/contact/schemas/phones.js